import React from 'react';
import { Header } from '../components/Header';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { FolderIcon, FileTextIcon, CalendarIcon } from 'lucide-react';
interface CasesScreenProps {
  onSelectCase: (caseId: string) => void;
  onLogout: () => void;
}
export function CasesScreen({
  onSelectCase,
  onLogout
}: CasesScreenProps) {
  const cases = [{
    id: 'case-1',
    name: 'Smith v. Acme Corp',
    matterNumber: 'MAT-2023-0891',
    documentCount: 2847,
    dateGranted: 'Oct 12, 2023'
  }, {
    id: 'case-2',
    name: 'In re: TechHoldings Merger',
    matterNumber: 'MAT-2023-1102',
    documentCount: 14502,
    dateGranted: 'Nov 05, 2023'
  }, {
    id: 'case-3',
    name: 'State of NY v. Horizon Logistics',
    matterNumber: 'MAT-2024-0045',
    documentCount: 892,
    dateGranted: 'Jan 18, 2024'
  }];
  return <div className="min-h-screen flex flex-col bg-navy" data-id="element-642" data-mp="kak3y2ce7z2l">
      <Header breadcrumbs={[{
      label: 'Cases'
    }]} onLogout={onLogout} data-id="element-643" data-mp="3185wu9awrpfg" />

      <main className="flex-1 p-8 max-w-6xl mx-auto w-full" data-id="element-644" data-mp="31a8wll1v4wxd">
        <div className="mb-8" data-id="element-645" data-mp="367s9agiwx1n7">
          <h1 className="text-3xl font-serif text-white mb-2" data-id="element-646" data-mp="3693femztylhh">Your Cases</h1>
          <p className="text-gray-400" data-id="element-647" data-mp="3b4iq562jk19o">
            Select a matter to begin document review.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-648" data-mp="3f5kqjq872jd8">
          {cases.map(c => <Card key={c.id} className="flex flex-col h-full" data-id="element-649" data-mp="3p5v4xe5ytwtz">
              <div className="p-6 flex-1" data-id="element-650" data-mp="3p4ab5qrh6hx6">
                <div className="flex items-start justify-between mb-4" data-id="element-651" data-mp="3twtn6jail4zv">
                  <div className="p-2 bg-navy-lighter rounded-lg" data-id="element-652" data-mp="3tyo83xlscx3y">
                    <FolderIcon className="w-6 h-6 text-amber" data-id="element-653" data-mp="2oz0eh12x0zd" />
                  </div>
                  <span className="text-xs font-medium text-gray-500 bg-navy px-2 py-1 rounded" data-id="element-654" data-mp="6swzwsubgdsy">
                    {c.matterNumber}
                  </span>
                </div>

                <h2 className="text-xl font-serif text-white mb-4 line-clamp-2" data-id="element-655" data-mp="27tlgi3fnwr9p">
                  {c.name}
                </h2>

                <div className="space-y-3 text-sm text-gray-400" data-id="element-656" data-mp="23tt0x6rupkuu">
                  <div className="flex items-center" data-id="element-657" data-mp="2hkg2d6ozxoum">
                    <FileTextIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-658" data-mp="2hl7pru8fwg9t" />
                    {c.documentCount.toLocaleString()} documents
                  </div>
                  <div className="flex items-center" data-id="element-659" data-mp="2rh185u8ub3zi">
                    <CalendarIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-660" data-mp="2rjx3datazek9" />
                    Access granted {c.dateGranted}
                  </div>
                </div>
              </div>

              <div className="p-4 border-t border-navy-lighter bg-navy/50" data-id="element-661" data-mp="30gej6rcm40mc">
                <Button fullWidth onClick={() => onSelectCase(c.id)} data-id="element-662" data-mp="2vk7e10s1it5g">
                  Open Case
                </Button>
              </div>
            </Card>)}
        </div>
      </main>
    </div>;
}